import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getAgent } from 'api/agents';
import Container from 'components/Container';
import Button from 'components/Button';
import { getConversation, getConversationMessages } from 'api/conversations';
import { exportToJson } from 'helpers/json';
import Page from 'components/Layout/Page';

import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

export default function Agent() {

    const { agentId, conversationId } = useParams();

    const { data: agent, isLoading } = useQuery({
        queryKey: ['agents', agentId],
        queryFn: async () => await getAgent({
            id: agentId
        }),
    });

    const { data: conversation, isLoading: isLoadingConversation, refetch } = useQuery({
        queryKey: ['conversations', conversationId],
        queryFn: async () => await getConversation({id: conversationId}),
        enabled: !!conversationId
    })

    const { data: messages, isLoading: loadingMessages } = useQuery({
        queryKey: ['conversations', conversationId, 'messages'],
        queryFn: async () => {
            const data = await getConversationMessages({id: conversationId});
            if(conversation?.status === "PENDING") {
                refetch()
            }
            return data;
        },
        refetchInterval: conversation?.status === "PENDING" ? 5000 : false,
        enabled: !!conversationId
    });

    const result = messages?.reduce((acc, msg) => {
        if(msg.data) {
            let messages = msg.data?.agent?.messages;
            return [
                ...acc,
                messages.map(m => `###${m.role}\n${m.content}`).join('\n\n')
            ]
        }
        return acc;
    }, []);

    const onDownloadHandler = () => {
        return exportToJson(result, `conversation-${conversationId || 'data'}.json`);
    };

    return (
        <>
            <Page isLoading={isLoading || isLoadingConversation || loadingMessages}>

                <Container>
                    <div className='w-full flex items-center gap-5'>
                        <div className='w-12 min-w-12 md:w-24 h-24 rounded-full bg-center bg-cover' style={{ backgroundImage: `url(${agent?.image || '/images/agent-avatar.jpg'})` }}></div>
                        <div>
                            <h1 className='text-xl md:text-3xl font-medium text-black pb-1'>{agent?.name}</h1>
                            <p className='text-muted'>{agent?.description}</p>
                        </div>
                    </div>

                    {result &&
                        <div className='w-full pt-10'>
                            <div className='flex justify-between items-center'>
                                <h3 className='text-black text-xl'>Risultati</h3>
                                <div className='flex items-center gap-4'>
                                    <Button to={`/agents/${agentId}/${agent?.slug}?conversation=${conversationId}`} >
                                        Aggiungi elementi
                                    </Button>
                                    <Button  component="button" onClick={onDownloadHandler} >
                                        Scarica
                                    </Button>
                                </div>
                            </div>
                            <div className='overflow-x-auto mt-2 border border-light rounded-sm'>
                                <table className='w-full border-collapse'>
                                    <tbody>
                                        {result.map((row, rowIndex) => (
                                            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-greydark' : 'bg-grey'}>
                                                <td  className='border border-greylight px-4 py-2 text-white whitespace-nowrap'>
                                                    <Markdown remarkPlugins={[remarkGfm]}>{row}</Markdown>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </Container>
            </Page>
        </>
    )
}
